import {
  default as ChargedOffIcon,
  default as PaidOffIcon,
  default as VoidedIcon,
} from "@mui/icons-material/Paid";
import LoanIcon from "../unit/svgIcon/LoanIcon";
import LoanList from "./LoanList";

const LoanDefaultIcon = () => {
  return <LoanIcon color="white" size="20.5px" />;
};

export default {
  list: LoanList,
  icon: LoanDefaultIcon,
  paidOffIcon: PaidOffIcon,
  chargedOffIcon: ChargedOffIcon,
  voidedIcon: VoidedIcon,
};
